module.exports = __webpack_public_path__ + "media/assets/login/icon-signup-4-6edce8d3d31c53e61886b09d533fbbc0.svg";